/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Liveroomendeddescription3Inputs */

const en_liveroomendeddescription3 = /** @type {(inputs: Liveroomendeddescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone who was inside has been told. The event stays.`)
};

const de_liveroomendeddescription3 = /** @type {(inputs: Liveroomendeddescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle, die drin waren, haben Bescheid bekommen. Das Event bleibt.`)
};

/**
* | output |
* | --- |
* | "Everyone who was inside has been told. The event stays." |
*
* @param {Liveroomendeddescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const liveroomendeddescription3 = /** @type {((inputs?: Liveroomendeddescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Liveroomendeddescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_liveroomendeddescription3(inputs)
	return de_liveroomendeddescription3(inputs)
});
export { liveroomendeddescription3 as "liveRoomEndedDescription" }